import React, { useState } from "react";
import { VideoCamera, ArrowSquareOut, MapPin } from "@phosphor-icons/react";
import CameraViewerModal from "./CameraViewerModal";

export default function CameraCard({ camera, dense }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={`camera-${camera.id}`}
        className={`group block w-full text-left bg-tac-surface/60 border border-tac-border hover:border-tac-primary/60 hover:bg-tac-surface2 rounded-sm transition-colors ${dense ? "p-3" : "p-4"}`}
      >
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 shrink-0 bg-tac-bg border border-tac-border rounded-sm flex items-center justify-center group-hover:border-tac-primary/60 transition-colors">
            <VideoCamera size={18} weight="duotone" className="text-tac-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-2 mb-0.5">
              <h4 className="font-display font-bold text-sm text-tac-text truncate">
                {camera.name}
              </h4>
              <ArrowSquareOut size={12} weight="bold" className="text-tac-faint group-hover:text-tac-primary shrink-0" />
            </div>
            <div className="text-[15px] font-mono-tac text-tac-faint uppercase tracking-wider">
              {camera.operator}
              {camera.distance_mi != null && (
                <span className="text-tac-primary"> · {camera.distance_mi} mi</span>
              )}
            </div>
            {!dense && camera.description && (
              <p className="text-[14px] text-tac-dim mt-1.5 leading-relaxed line-clamp-2">
                {camera.description}
              </p>
            )}
            <div className="flex items-center gap-1 mt-1.5 text-[15px] font-mono-tac tabular text-tac-faint">
              <MapPin size={9} weight="fill" />
              {camera.lat.toFixed(3)}, {camera.lon.toFixed(3)}
            </div>
          </div>
        </div>
      </button>
      {open && <CameraViewerModal camera={camera} onClose={() => setOpen(false)} />}
    </>
  );
}
